function Select({value , onchange}) {
    return (
<select value={value} onChange={onchange} >
          <option value="no-value" disabled="">
            Choisir une caisse régionale
          </option>

          <option value="/ca-alpesprovence/">Alpes Provence</option>

          <option value="/ca-alsace-vosges/">Alsace Vosges</option>

          <option value="/ca-anjou-maine/">Anjou Maine</option>

          <option value="/ca-aquitaine/">Aquitaine</option>

          <option value="/ca-atlantique-vendee/">Atlantique Vendée</option>

          <option value="/ca-briepicardie/">Brie Picardie</option>

          <option value="/ca-centrest/">Centre Est</option>

          <option value="/ca-centrefrance/">Centre France</option>

          <option value="/ca-centreloire/">Centre Loire</option>

          <option value="/ca-centreouest/">Centre Ouest</option>

          <option value="/ca-cb/">Champagne Bourgogne</option>

          <option value="/ca-cmds/">Charente Maritime Deux-Sèvres</option>

          <option value="/ca-charente-perigord/">Charente Périgord</option>

          <option value="/ca-corse/">Corse</option>

          <option value="/ca-cotesdarmor/">Côtes d'Armor</option>

          <option value="/ca-des-savoie/">Des Savoie</option>

          <option value="/ca-finistere/">Finistère</option>

          <option value="/ca-franchecomte/">Franche Comté</option>

          <option value="/ca-guadeloupe/">Guadeloupe</option>

          <option value="/ca-illeetvilaine/">Ille et Vilaine</option>

          <option value="/ca-languedoc/">Languedoc</option>

          <option value="/ca-loirehauteloire/">Loire Haute-Loire</option>

          <option value="/ca-lorraine/">Lorraine</option>

          <option value="/ca-martinique/">Martinique Guyane</option>

          <option value="/ca-morbihan/">Morbihan</option>

          <option value="/ca-norddefrance/">Nord De France</option>

          <option value="/ca-nord-est/">Nord Est</option>

          <option value="/ca-nmp/">Nord Midi Pyrénées</option>

          <option value="/ca-normandie/">Normandie</option>

          <option value="/ca-normandie-seine/">Normandie Seine</option>

          <option value="/ca-paris/">Paris et Île de France</option>

          <option value="/ca-pca/">Provence Côte d'Azur</option>

          <option value="/ca-pyrenees-gascogne/">Pyrénées Gascogne</option>

          <option value="/ca-reunion/">Réunion</option>

          <option value="/ca-sudmed/">Sud Méditerranée</option>

          <option value="/ca-sudrhonealpes/">Sud Rhône Alpes</option>

          <option value="/ca-toulouse31/">Toulouse 31</option>

          <option value="/ca-tourainepoitou/">Touraine Poitou</option>

          <option value="/ca-valdefrance/">Val De France</option>
        </select>
    )
}

export default Select
